import { BellRing, FileCheck2, MessageSquare, TrendingDown, Users } from "lucide-react";

const KpiCard = ({ icon: Icon, label, value, hint, tone = "default" }) => (
  <div data-testid="admin-kpi-card" className="tt-card p-5">
    <div className="flex items-start justify-between gap-3">
      <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-muted-foreground">
        {label}
      </p>
      <span
        className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
          tone === "warn"
            ? "bg-[color:var(--tt-warn-bg)] text-[color:var(--tt-warn-text)]"
            : "bg-[color:var(--tt-teal-mist)] text-primary"
        }`}
      >
        <Icon className="h-4 w-4" aria-hidden="true" />
      </span>
    </div>
    <p className="mt-3 font-amount text-3xl font-bold leading-none text-foreground">{value}</p>
    {hint ? <p className="mt-2 text-xs leading-relaxed text-muted-foreground">{hint}</p> : null}
  </div>
);

const DASH = "\u2014";

/** The five headline numbers across the top of the overview. */
export const DashboardKpis = ({ stats }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5">
    <KpiCard
      icon={FileCheck2}
      label="Quotes this week"
      value={stats ? stats.quotes_week : DASH}
      hint={stats ? `${stats.quotes_month} in the last 30 days` : null}
    />
    <KpiCard
      icon={Users}
      label="Completed the gate"
      value={stats ? stats.completed_gate : DASH}
      hint={
        stats
          ? `${stats.started_questions} started answering · ${stats.reached_gate} reached the gate`
          : null
      }
    />
    <KpiCard
      icon={TrendingDown}
      label="Drop-off rate"
      value={stats ? `${stats.drop_off_rate}%` : DASH}
      tone="warn"
      hint={
        stats
          ? `${stats.drop_off_count} started but never got a quote · ${stats.gate_abandon_rate}% abandoned at the gate itself`
          : null
      }
    />
    <KpiCard
      icon={MessageSquare}
      label="Fallback requests"
      value={stats ? stats.fallback_forms : DASH}
      hint={stats ? `${stats.fallback_sessions} sessions hit a fallback rule` : null}
    />
    <KpiCard
      icon={BellRing}
      label="Needs chasing"
      value={stats ? stats.gone_quiet : DASH}
      tone={stats?.gone_quiet ? "warn" : undefined}
      hint={
        stats
          ? `Open with no activity for ${stats.gone_quiet_days}+ days · ${stats.action_overdue} action${
              stats.action_overdue === 1 ? "" : "s"
            } overdue`
          : null
      }
    />
  </div>
);
